import React, { useCallback, useEffect, useRef } from "react";
import cns from "classnames";
import { IContract } from "types";
import { ReactComponent as ArrowIcon } from "icons/arrow.svg";
import { Contract } from "../../containers/Contract";
import styles from "./ListItem.module.scss";

interface ItemProps {
  contract: IContract;
  active: boolean;
  setActive: (id?: number) => void;
  measure?: () => void;
}

export const ListItem = ({
  contract,
  measure,
  active,
  setActive,
}: ItemProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  // Эффект для измерения высоты контента при активации
  useEffect(() => {
    if (active && contentRef.current && measure) {
      measure();
    }
  }, [active, measure]);

  const handleToggle = () => {
    setActive(active ? undefined : contract.idContract);
  };

  const isClosed = Boolean(contract.dateClose);

  return (
    <div className={cns(styles.item, { [styles["item-active"]]: active })}>
      <div
        className={isClosed ? styles.headerClosed : styles.header}
        onClick={handleToggle}
      >
        <span className={styles.title}>
          <span className={styles.titleBold}>{contract.numContract}</span>
        </span>
        <div className={styles.arrow}>
          <ArrowIcon />
        </div>
      </div>

      {active && (
        <div className={styles.listContent} ref={contentRef}>
          <Contract measure={measure} contract={contract} />
        </div>
      )}
    </div>
  );
};
